import type {
	CreateReviewTemplateRequestInput,
	ReviewTemplateResponse as ReviewTemplateV2ApiResponse,
	ReviewTemplateWithNames,
	UpdateReviewTemplateRequestInput,
} from "@performyard/service-contracts";

import internalRequest from "./internal-api/internal-base-request";

export type { ReviewTemplateWithNames, TemplateFormAssignmentWithNames } from "@performyard/service-contracts";

const BASE_PATH = "/v1/reviews/review-templates";

/**
 * v2: `GET /v1/reviews/review-templates/:templateId`. Returns the template with form
 * names and resolved participant names baked into `formAssignments`.
 */
export const fetchReviewTemplateV2 = async (templateId: string): Promise<ReviewTemplateWithNames> => {
	const [response] = await internalRequest<ReviewTemplateV2ApiResponse>(`${BASE_PATH}/${templateId}`);
	return response.data;
};

export const createReviewTemplateV2 = async (
	data: CreateReviewTemplateRequestInput
): Promise<ReviewTemplateWithNames> => {
	const [response] = await internalRequest<ReviewTemplateV2ApiResponse>(BASE_PATH, {
		method: "POST",
		body: JSON.stringify(data),
	});
	return response.data;
};

export const updateReviewTemplateV2 = async (
	templateId: string,
	data: UpdateReviewTemplateRequestInput
): Promise<ReviewTemplateWithNames> => {
	const [response] = await internalRequest<ReviewTemplateV2ApiResponse>(`${BASE_PATH}/${templateId}`, {
		method: "PUT",
		body: JSON.stringify(data),
	});
	return response.data;
};

export const deleteReviewTemplateV2 = async (templateId: string): Promise<void> => {
	await internalRequest(`${BASE_PATH}/${templateId}`, { method: "DELETE" });
};
